import { render } from "./GSAxb.vue?vue&type=template&id=36f285b8&scoped=true"
import script from "./GSAxb.vue?vue&type=script&lang=js"
export * from "./GSAxb.vue?vue&type=script&lang=js"

import "./GSAxb.vue?vue&type=style&index=0&id=36f285b8&scoped=true&lang=css"
import "./GSAxb.vue?vue&type=style&index=1&id=36f285b8&lang=css"
script.render = render
script.__scopeId = "data-v-36f285b8"

export default script